import AnswerRecap from "@/components/storyboard/AnswerRecap";

interface QuizReviewTextProps {
  userAnswer: string;
}

/**
 * Neutral free-text answer echo in quiz review — verdict color stays on the
 * review score/feedback chrome, not on the answer recap.
 */
const QuizReviewText = ({ userAnswer }: QuizReviewTextProps) => (
  <AnswerRecap value={userAnswer.trim() !== "" ? userAnswer : "—"} />
);

export default QuizReviewText;
